import ArrowSvg from "./ArrowSvg";
import DatabaseSvg from "./DatabaseSvg";
import DateInputSvg from "./DateInputSvg";
import DownloadSvg from "./DownloadSvg";
import FullNameCopySvg from "./FullNameCopySvg";
import GenerateSvg from "./GenerateSvg";
import PreviewSvg from "./PreviewSvg";
import RefreshSvg from "./RefreshSvg";
import TrashSvg from "./TrashSvg";

export const AODSvgExport = {
  ArrowSvg,
  DatabaseSvg,
  DateInputSvg,
  DownloadSvg,
  FullNameCopySvg,
  GenerateSvg,
  PreviewSvg,
  RefreshSvg,
  TrashSvg,
};
